var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WidgetDatatableTabs',{attrs:{"items":_vm.data.data,"nbHeaders":1,"nbTabs":0,"headersList":_vm.headers,"defaultTarget":"count","showTotal":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.conf.title))]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }